module.exports = __webpack_public_path__ + "img/whathot_bg_mobile.2301af48.png";